package com.anjuros.website.redesign.sections.about

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.AboutBrandsLabelStyle
import com.anjuros.website.redesign.styles.AboutBrandsListStyle
import com.anjuros.website.redesign.styles.AboutBrandsRowStyle
import com.anjuros.website.redesign.styles.AboutBrandsStyle
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.rdList
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** Pale-blue band naming the UK brands I've built products for. */
@Composable
fun AboutBrandsSection() {
    val label = LocalText(RdText.ABOUT_BRANDS_LABEL)
    RdSection(
        modifier = AboutBrandsStyle.toModifier().attrsModifier { attr("aria-label", label) },
        wrapModifier = AboutBrandsRowStyle.toModifier(),
    ) {
        P(AboutBrandsLabelStyle.toModifier().toAttrs()) { Text(LocalText(RdText.ABOUT_BRANDS_TITLE)) }
        Ul(AboutBrandsListStyle.toModifier().toAttrs()) {
            rdList(LocalText(RdText.ABOUT_BRANDS)).forEach { Li { Text(it) } }
        }
    }
}
